import { supabase } from '@/integrations/supabase/client';
import { ClassifiedError } from './errorTypes';

export const logErrorToAuditLogs = async (
  classifiedError: ClassifiedError,
  context?: {
    action?: string;
    table_name?: string;
    record_id?: string;
    component?: string;
  }
): Promise<void> => {
  try {
    const logData = {
      category: classifiedError.category,
      message: classifiedError.message,
      userMessage: classifiedError.userMessage,
      retryable: classifiedError.retryable,
      code: classifiedError.code,
      field: classifiedError.field,
      component: context?.component,
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
      url: window.location.href
    };

    // Use RPC function to bypass RLS blocking direct inserts
    await supabase.rpc('log_client_error', {
      _action: context?.action || `error_${classifiedError.category}`,
      _table_name: context?.table_name || 'system',
      _record_id: context?.record_id || null,
      _new_values: logData
    });
  } catch (error) {
    // Silently fail logging to avoid error loops
    console.error('Failed to log error to audit_logs:', error);
  }
};

export const logErrorToConsole = (
  classifiedError: ClassifiedError,
  context?: string
): void => {
  const prefix = context ? `[${context}]` : '[Error]';
  console.error(`${prefix} ${classifiedError.category}:`, {
    message: classifiedError.message,
    userMessage: classifiedError.userMessage,
    retryable: classifiedError.retryable,
    code: classifiedError.code,
    field: classifiedError.field,
    originalError: classifiedError.originalError
  });
};
